import { call, put, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { ILopSelectRequest } from '../../../models/request/dm-lop/ILopSelectRequest';
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eLopChuNhiemActionTypeIds } from "../../action-types/lop-chu-nhiem/ILopChuNhiemActionTypes";
import { actions } from "../../actions/actionsWrapper";
import { ILopChuNhiemActionTypes } from './../../action-types/lop-chu-nhiem/ILopChuNhiemActionTypes';

export function* lopChuNhiemSaga(): any {
    yield takeLatest(eLopChuNhiemActionTypeIds.SELECT_START, selectWorker)
}

function* selectWorker(data: ILopChuNhiemActionTypes): any {
    const res: IBaseResponeModel = yield call([apiWrapper.lop, apiWrapper.lop.Select], data.payload as ILopSelectRequest)
    if (res.is_success) {
        yield put(actions.lopChuNhiem.SELECT_SUCCESS(res.data))
    } else {
        yield put(actions.lopChuNhiem.SELECT_ERROR(res.message || "Không tải được lớp"))
    }
}